import {
    BASE_URL, 
    POST,  
    INCIDENT_REQUEST,
    PATCH,
  } from "../constants";
  import { statusParsing, jsonParsing } from "../utils";
  import { getAccessToken } from "../../authActions/authActions";
  
  export const addIncidentRequest = async (payload) => {
    const token = await getAccessToken();
    const resource =  `${BASE_URL}${INCIDENT_REQUEST}`;
    return fetch(resource, {
      method: POST,
      headers: {
        "Content-Type": "application/json",
        "userauth": `Bearer ${token}`
      },
      body: JSON.stringify(payload)
    })
      .then(statusParsing)
      .then(jsonParsing);
  };
  
  export const addAdditionalEmail = async (payload ,id) => {
    const token = await getAccessToken();
    const resource = `${BASE_URL}${INCIDENT_REQUEST}/${id}/${"additional-emails"}`;
    return fetch(resource, {
      method: PATCH,
      headers: {
        "Content-Type": "application/json",
        "userauth": `Bearer ${token}`
      },
      body: JSON.stringify(payload)
    })
      .then(statusParsing)
      .then(jsonParsing);
  };
  
  